'use strict'
/* eslint-disable */

const NUM_EVAL_QUESTIONS = 10	// count of required questions.
const EXAM_MIN_SCORE_TO_PASS = 80  // min score to pass exam

// Constants used in logEvent()
const VIVA_EVENT_LOGIN = 1
const VIVA_EVENT_LOGOUT = 2
const VIVA_EVENT_VIEW_CLASS = 3
const VIVA_EVENT_EVALUATION = 4
const VIVA_EVENT_FAIL_EXAM = 5
const VIVA_EVENT_PASS_EXAM = 6
const VIVA_EVENT_VIEW_MOVIE = 19
const VIVA_EVENT_VIEW_PODCAST = 20

const VPAD_LOGIN = 1
const VPAD_TOP = 2
const VPAD_SLIDER = 3		// Old home page slides
const VPAD_HOMESLIDE = 4  	// New home page slider.
const VPAD_RIGHT = 5
const VPAD_LEFT = 6			// Left side banner ad.
const VPAD_CONTENT_TOP = 7
const VPAD_CONTENT_LIST1 = 8	// Pos 1 of 4
const VPAD_CAT_TOP = 9
const VPAD_CAT_LIST1 = 10		// see 2,3,4 below
const VPAD_TRENDING = 11
const VPAD_CE = 12				// Uses classes.isVpFeatured
const VPAD_TIP = 13			    // Uses tips.isVpFeatured
const VPAD_PRODUCT = 14			// Uses classes.isVpFeatured (tutorials)
const VPAD_PROMOTION = 15
const VPAD_NEW_PRODUCT = 16		// Used for uploading photo.
const VPAD_PRESS = 17
const VPAD_ACTIVITY = 18		// Ad on user activity pages.
const VPAD_CAT_ALT_TOP = 19		// Alternate small banner ad on classroom page.
const VPAD_CAT_ALT_LIST = 20	// Alternate small banner ad on classroom page.
const VPAD_CESPOTLIGHT = 21		// Left side on home page. Uses classes.isCeSpotlight
const VPAD_EXAMBLURBLINK = 22	// Click tracking for exam blurb links
const VPAD_PODCAST_PROMOTION = 23	// Click tracking for Podcast Special Offers
const VPAD_EXAM = 24			// Click tracking for exam ads
const VPAD_EXAMEMAIL = 25		// Tracking for exam emails.
const VPAD_LEFTCONTENT = 26		// Tracking for left side content
const VPAD_CONTENT_LIST2 = 27	// Pos 2 of 4
const VPAD_CONTENT_LIST3 = 28	// Pos 3 of 4
const VPAD_CONTENT_LIST4 = 29	// Pos 4 of 4
const VPAD_CAT_LIST2 = 30		// see 1 above
const VPAD_CAT_LIST3 = 31
const VPAD_CAT_LIST4 = 32
const VPAD_EBOOK = 33
const VPAD_EBOOK_THUMBNAIL = 34	        // Thumbnail  used on VP ebook page
const VPAD_RIGHT_INTERNAL = 35		    //  Right Internal
const VPAD_FEATURED_CLASS = 36		    //  Featured CE Class for a category
const VPAD_FEATURED_PODCAST = 37		//  Featured CE Podcast for a category
const VPAD_FEATURED_PREMIUM = 49		//  Featured Premium Class

const constants = {
    CANONICAL_BASE: "https://m.vivalearning.com",
    LEARNWORLDS_BASE: 'https://vivalearning.learnworlds.com/payment?product_id=',
    CLASS_TYPE: {
        UNDEFINED: 0,
        PDF: 10,
        LIVE: 20,
        ARCHIVE: 30,
        PRODUCED: 40,		    // regular flash class and produced live classes
        PRODUCED_ARCHIVE: 50,	// produced classes from live classes (old style)
        MOVIE: 55,		        // WMV, MP3 or MOV
        LUNCHLEARN: 60,
        PRODUCED_PLAYBACK: 70,	// playback classes from live classes (kerman style)
        SLIDESHOW: 80,			//  TBD
        SEMINAR: 90,			    // Edge Endo Seminar - live CE
        PREMIUM: 100            // LearnWorlds, HotMart
    },
    CE_TYPEID: {
        NONCE: 0,            // Placeholder for NON-CE tutorials
        HOMESTUDY: 1,       // Self-Study
        PARTICIPATORY: 2    // Live Interactive
    },
    VPAD_SLOT_TYPE: {
        VPAD_LOGIN: 1,
        VPAD_TOP: 2,
        VPAD_SLIDER: 3,		// Old home page slides
        VPAD_HOMESLIDE: 4,  	// New home page slider.
        VPAD_RIGHT: 5,
        VPAD_LEFT: 6,			// Left side banner ad.
        VPAD_CONTENT_TOP: 7,
        VPAD_CONTENT_LIST1: 8,	// Pos 1 of 4
        VPAD_CAT_TOP: 9,
        VPAD_CAT_LIST1: 10,		// see 2,3,4 below
        VPAD_TRENDING: 11,
        VPAD_CE: 12,				// Uses classes.isVpFeatured
        VPAD_TIP: 13,			    // Uses tips.isVpFeatured
        VPAD_PRODUCT: 14,			// Uses classes.isVpFeatured (tutorials)
        VPAD_PROMOTION: 15,
        VPAD_NEW_PRODUCT: 16,		// Used for uploading photo.
        VPAD_PRESS: 17,
        VPAD_ACTIVITY: 18,		// Ad on user activity pages.
        VPAD_CAT_ALT_TOP: 19,		// Alternate small banner ad on classroom page.
        VPAD_CAT_ALT_LIST: 20,	// Alternate small banner ad on classroom page.
        VPAD_CESPOTLIGHT: 21,		// Left side on home page. Uses classes.isCeSpotlight
        VPAD_EXAMBLURBLINK: 22,	// Click tracking for exam blurb links
        VPAD_PODCAST_PROMOTION: 23,	// Click tracking for Podcast Special Offers
        VPAD_EXAM: 24,			// Click tracking for exam ads
        VPAD_EXAMEMAIL: 25,		// Tracking for exam emails.
        VPAD_LEFTCONTENT: 26,		// Tracking for left side content
        VPAD_CONTENT_LIST2: 27,	// Pos 2 of 4
        VPAD_CONTENT_LIST3: 28,	// Pos 3 of 4
        VPAD_CONTENT_LIST4: 29,	// Pos 4 of 4
        VPAD_CAT_LIST2: 30,		// see 1 above
        VPAD_CAT_LIST3: 31,
        VPAD_CAT_LIST4: 32,
        VPAD_EBOOK: 33,
        VPAD_EBOOK_THUMBNAIL: 34,	        // Thumbnail  used on VP ebook page
        VPAD_RIGHT_INTERNAL: 35,		    //  Right Internal
        VPAD_FEATURED_CLASS: 36,		    //  Featured CE Class for a category
        VPAD_FEATURED_PODCAST: 37,		    //  Featured CE Podcast for a category
        VPAD_FEATURED_PREMIUM: 49           // Featured Premium
    },
    VPAD_EVENTID: {
        VIEW: 1,    // View of VP Ad
        CLICK: 2    // Click of VP Ad
    },
    PATHS: {
        ON_DEMAND_BASE: "/on-demand-dental-ce-course",
        PREMIUM_BASE: "/premium-dental-ce-course",
        PODCAST_BASE: "/dental-podcasts",
    }
}

module.exports = constants



// WEBPACK FOOTER //
// ./src/config/constants.js